// 手机点餐——美团，主流程
const mtMainRoutes = Array.from({ length: 19 }, (_, i) => ({
  path: `eat/mt/index${i + 1}`,
  name: `eatMtIndex${i + 1}`,
  component: () => import(`@/views/shopping/eat/mt/index${i + 1}.vue`),
}));

// 手机点餐——饿了么，主流程
const elmMainRoutes = Array.from({ length: 19 }, (_, i) => ({
  path: `eat/elm/index${i + 1}`,
  name: `eatElmIndex${i + 1}`,
  component: () => import(`@/views/shopping/eat/elm/index${i + 1}.vue`),
}));
const jdMainRoutes = Array.from({ length: 11 }, (_, i) => ({
  path: `eat/jd/index${i + 1}`,
  name: `eatjdIndex${i + 1}`,
  component: () => import(`@/views/shopping/eat/jd/index${i + 1}.vue`),
}));

export default {
  path: "/shopping",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    // 手机点餐——美团，主流程
    ...mtMainRoutes,

    // 手机点餐——饿了么，主流程
    ...elmMainRoutes,
    ...jdMainRoutes,
  ],
};
